export const wrapper = (centerAligned: boolean, narrow = false) => ({
	display: 'flex',
	textAlign: centerAligned ? 'center' : 'left',
	justifyContent: centerAligned ? 'center' : 'start',
	alignItems: centerAligned ? 'center' : 'start',
	width: '100%',
	padding: {
		xs: '2rem 0.625rem',
		sm: '2.625rem 1.5rem',
		md: '2.625rem 2.5rem',
	},
	maxWidth: {
		sm: '100%',
		// Use 'lg' breakpoint when narrow (scheduling widget present) for more space,
		// otherwise use 'md' breakpoint for normal behavior
		...(narrow ? { md: '100%', lg: '48%' } : { md: '50%' }),
	},
});

export const textContainerStyles = (centerAligned: boolean) => ({
	display: 'flex',
	minWidth: { sm: '25.25rem' },
	maxWidth: '42.25rem',
	alignSelf: centerAligned ? 'center' : 'start',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: centerAligned ? 'center' : 'start',
	gap: '1rem',
	height: '100%',
});

export const contentListWrapperStyles = {
	display: 'flex',
	alignItems: 'center',
	width: '100%',
	flexFlow: 'column',
};

export const ctaButtonWrapperStyles = (centerAligned: boolean) => ({
	display: 'flex',
	gap: '0.75rem',
	flexWrap: 'wrap',
	justifyContent: centerAligned ? 'center' : 'start',
	alignItems: centerAligned ? 'center' : 'start',
	paddingTop: '0.75rem',
	'& > a': {
		width: 'auto',
	},
});

export const TACWrapperStyles = { paddingTop: { xs: '1.25rem', md: '0' } };
